import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentNumberSettingComponent } from './document-number-setting.component';

export const documentNumberSettingRoutes: Routes = [
  {
    path: 'document-number-setting',
    component: DocumentNumberSettingComponent,
    data: {
      'expectedRoles': ['Accountant Admin', 'Admin']
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(documentNumberSettingRoutes)],
  exports: [RouterModule]
})
export class DocumentNumberSettingRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting-routing.module.ts